export const DATA_AS_NAV_TAB_ATTR = 'data-as-nav-tab';
